







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    Info: () => import('./modules/lesson-detail/info.vue'),
    Student: () => import('./modules/lesson-detail/student.vue'),
    Doc: () => import('./modules/lesson-detail/doc.vue')
  }
})
export default class Lesson extends Vue {
  private courseId = '';
  private mounted() {
    this.setCourseId();
  }
  private setCourseId() {
    let id: any = this.$route.query.courseId;
    this.courseId = id ? id : '';
  }
}
